import { type LanguageCode } from 'iso-639-1'
import { type Language, LanguageLevel } from '../types/Language.ts'

export const LANGUAGES_SORTED: LanguageCode[] = [
    'sk',
    'en',
    'cs',
    'hu',
    'pl',
    'de',
    'fr',
    'it',
    'da',
    'nl',
    'hr',
    'ru',
    'es',
    'zh',
    'ja'
]

export const DEFAULT_LANGUAGE: Partial<Language> = {
    code: undefined,
    level: LanguageLevel.A1
}